import React from 'react'
import Input from '../../../UIComponents/Input/Input'
import { TestReportRightSection } from './TestReportRightSection'
import ReportFooter from './ReportFooter'
import './Fsh.css'
import { useDispatch,useSelector } from 'react-redux'
import { useState } from 'react'
import { updateReports } from '../../../redux/actions/Diagnostics/diagnostics'

export const Fsh = () => {
  const dispatch =  useDispatch()
  const reportDataFields = useSelector(state => state?.diagnosticsInvoiceSummary?.getdiagnostic)
  const indexValue = useSelector(state => state?.diagnosticsInvoiceSummary?.indexValue)  
  const [ inputValue, setInputValue ] = useState("")

  const onInputChange = (e) => {
    console.log("e",e.target);
    const { value, name } = e.target;
    setInputValue(value)
    const filterData = reportDataFields?.testReport?.filter(item => item?.test === 'FSH')
    let index = 0
    reportDataFields?.testReport?.map((item, i) => {
      if(item.test === 'FSH'){
        index = i
      }
      return item
    })
    console.log("index",index);
    const finalFilteredData = filterData[0]?.fields?.map(item => {
      if(item.particular === name){
        item.result = value
      }
      return item
    })
     filterData[0].fields =  finalFilteredData
    reportDataFields.testReport[index]  = filterData[0]
    console.log("knklenknek",reportDataFields?.testReport[index]?.fields);
    setInputValue(reportDataFields?.testReport[index]?.fields)
    dispatch(updateReports(reportDataFields))
  }
  return (
    <div>
        <div className='fsh-parent'>
          <div className='fsh-left'>
            <div className='fsh-grid'>
                <div className='fsh1'></div>
                <div className='fsh2 fsh-pad'>FOLLICLE STIMULATING HORMONE</div>
                <div className='fsh3'><Input type='number' className={'fsh-input'} name="FOLLICLE STIMULATING HORMONE" onChange={onInputChange} value={reportDataFields?.testReport?.[indexValue]?.fields?.[0]?.result}  disabled={!reportDataFields.active}/></div>
                <div className='fsh4 fsh-pad'>mlU/ml</div>
                <div className='fsh5'></div>
                <div className='fsh6'></div>
            </div>
          </div>
          <div>
              <TestReportRightSection />
          </div>
        </div>
        <div className='fsh-foot'>
            <ReportFooter />
        </div>
        <div className='fsh-p'>
          <h4>Normal Range:</h4>
          <p>Males <span>2.1-18.6 mlU/ml</span></p>
          <p>Ovulating females <span>4.5-11.0 mlU/ml</span></p>
          <p>Mid-Cycle <span>3.6-20.6 mlU/ml </span></p>
          <p>Luetal Phase  <span>1.5-10.8 mlU/ml</span></p>
          <p>Postmenopaulsal females  <span>36.6-168.7 mlU/ml</span></p>
        </div>
        <div className='fsh-msr'>
          Measured using Optical Fluorescence Method 
        </div>
    </div>
  )
}
